import React from 'react'
import PropTypes from 'prop-types'

import styles from './../style/Raschet.module.scss'

import { Container, Image } from 'react-bootstrap'

import SimleForm from './SimleForm'

class Podarok extends React.Component {

  render() {

    const { assets_path, data, dark_bg, dark_bg_mob } = this.props

    return (
      <section className={styles.section}>
        {dark_bg != '' &&
          <>
            <Image className={styles.section_bg} src={dark_bg} width={1920} height={299} alt={`Фон`} />
            <Image className={styles.section_bg_mob} src={dark_bg_mob} width={375} height={482} alt={`Фон моб.`} />
          </>
        }
        <div className={styles.section_content}>
          <Container>
            <h2 className={styles.title} dangerouslySetInnerHTML={{__html: data?.title}} />
            <div className={styles.text} dangerouslySetInnerHTML={{__html: data?.text}} />
            <div className={styles.section_price}>
              Бесплатно <span>{data?.price} р</span>
            </div>
            <SimleForm
              btn={`Получить подарок`}
              assets_path={assets_path}
              width={204}
              name={true}
            />
            {data?.image != '' &&
              <div className={styles.section_image_container}>
                <Image className={styles.section_image} src={data?.image} alt={`${data?.title} - фото`} width={571} height={331} />
                <Image className={styles.section_image_mob} src={data?.image_mob} alt={`${data?.title} - фото моб.`} width={375} height={283} />
              </div>
            }
          </Container>
        </div>
      </section>
    )
  }
}

Podarok.propTypes = {
  data: PropTypes.object,
  assets_path: PropTypes.string,
  dark_bg: PropTypes.string,
  dark_bg_mob: PropTypes.string
}

Podarok.defaultProps = {
  data: {},
  assets_path: 'assets',
  dark_bg: '',
  dark_bg_mob: ''
}

export default Podarok